import { Injectable } from '@angular/core';
import Intercom from "@intercom/messenger-js-sdk";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class IntercomService {

  constructor() { }

  /**
   * Initializes Intercom with the application ID from the environment configuration.
   * This method sets up Intercom to hide the default launcher.
   */
  initIntercom(): void {
    Intercom({
      app_id: environment.intercomAppId,
      hide_default_launcher: true,
    });
  }
}
